const INITIAL_STATE = {
  collectionDetail: {},
  addonCollectionDetail: {},
  dashboardStat: {},
  customerMatrix: {},
  customerMatrixV1: {},
  errors: {},

}
const franchiseOverview = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_COLLECTION_DETAIL':
    return { ...INITIAL_STATE, collectionDetail: action.data }
  case 'GET_COLLECTION_DETAIL_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  case 'GET_ADDON_COLLECTION_DETAIL':
    return { ...INITIAL_STATE, addonCollectionDetail: action.data }
  case 'GET_ADDON_COLLECTION_DETAIL_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  case 'GET_DASHBOARD_STAT':
    return { ...INITIAL_STATE, dashboardStat: action.data }
  case 'GET_DASHBOARD_STAT_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  case 'GET_CUSTOMER_MATRIX':
    return { ...INITIAL_STATE, customerMatrix: action.data }
  case 'GET_CUSTOMER_MATRIX_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  case 'GET_CUSTOMER_MATRIX_V1':
    return { ...INITIAL_STATE, customerMatrixV1: action.data }
  case 'GET_CUSTOMER_MATRIX_V1_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};

export default franchiseOverview;